import type { ShopTemplateBlock } from "./types";

export const CATALOG_PRODUCT_DETAIL_DESIGN_OPTION = "productDetailDesign";

export const CATALOG_PRODUCT_DETAIL_DESIGNS = [
    "default",
    "editorialSplit",
    "utilitySplit",
    "boutiqueSplit",
    "playfulSplit",
    "commerceSplit",
] as const;

export type CatalogProductDetailDesign = typeof CATALOG_PRODUCT_DETAIL_DESIGNS[number];

export const DEFAULT_CATALOG_PRODUCT_DETAIL_DESIGN: CatalogProductDetailDesign = "default";

export function catalogProductDetailDesign(
    galleryBlock: ShopTemplateBlock | null | undefined,
): CatalogProductDetailDesign {
    const value = galleryBlock?.options?.[CATALOG_PRODUCT_DETAIL_DESIGN_OPTION];

    if (typeof value !== "string") {
        return DEFAULT_CATALOG_PRODUCT_DETAIL_DESIGN;
    }

    if (CATALOG_PRODUCT_DETAIL_DESIGNS.includes(value as CatalogProductDetailDesign)) {
        return value as CatalogProductDetailDesign;
    }

    return DEFAULT_CATALOG_PRODUCT_DETAIL_DESIGN;
}

export function withCatalogProductDetailDesign(
    galleryBlock: ShopTemplateBlock,
    design: CatalogProductDetailDesign,
): ShopTemplateBlock {
    return {
        ...galleryBlock,
        options: {
            ...(galleryBlock.options ?? {}),
            [CATALOG_PRODUCT_DETAIL_DESIGN_OPTION]: design,
        },
    };
}
